import { FormInputNumber } from "../../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../../../config/optionsConstants";
import { validateInternalTransport } from "../../../../../../utils/utils";
import { InternalTransportSectionProps } from "../internalTransport.types";

const InternalTransportFreightDistanceSection = ({ control, disabled }: InternalTransportSectionProps) => (
  <div className="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-4 md:tw-grid-cols-2">
    <FormInputNumber
      control={control}
      name="averageDistance"
      label="Average Distance from Field(s) to Facility (km)"
      placeholder="0"
      required
      disabled={disabled}
      errorMessage="Please enter average distance"
      rules={{
        validate: (v: unknown) => validateInternalTransport(v)
      }}
    />
    <FormUnitInput
      control={control}
      name="weight"
      unitName="weightUnit"
      label="Weight"
      placeholder="0"
      required
      disabled={disabled}
      errorMessage="Weight is required"
      unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
      validate={{
        validateNumber: (v: unknown) => validateInternalTransport(v)
      }}
    />
  </div>
);

export default InternalTransportFreightDistanceSection;
